import AuditTrail from "../audit.trail";

export const CheckLog = (WrappedComponent) => (props) => {
  const { onChange, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          let data = Object.assign({tag: 'checkbox', event: action, label: props.label? props.label : ''}, eventParams);
          data.value = props.bool;
          AuditTrail.sendLog(event, data);
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onChange={(context) => {
            onLog(event, 'onChange', eventParams);
            if (props.onChange) {
                props.onChange(context);
            }
        }}
    />
  );
};
